import { Col, Row } from "react-bootstrap"
import { useAuth } from "../hooks"
import { toAbsoluteUrl } from "../helpers"
import { Layout } from "../layouts"
import { formatCurrency } from "../utilities"

const GiftCardsPage = () => {
  const { customer } = useAuth();

  return (
     <Layout>
          <div className="choose_payment_method_main offer-and-reward">
               <h2 className="page-heading">Gift Card</h2>
               <div className="offer_reward_banner loyalty_banner">
                    <Row>
                         <Col md={6}>
                              <div className="offer_reward_bann">
                                   <img src={toAbsoluteUrl("images/group171.png")} alt="" />
                              </div>
                         </Col>
                         <Col md={6}>
                              <div className="loyalty_bann">
                                   <h4>Gift Card <span>Available balance {formatCurrency(customer?.giftcard)}</span></h4>
                              </div>
                         </Col>
                    </Row>
               </div>
               {/* <h3>Points History  <span className="december_row">December 2021</span></h3> */}
               {/* 
                    <LoyaltyPointsHistory order={order} />
                    <LoyaltyPointsHistory order={order} />
                    <LoyaltyPointsHistory order={order} />
                    <LoyaltyPointsHistory order={order} />
                    <LoyaltyPointsHistory order={order} /> 
               */}
          </div>
    </Layout>
  )
}

export default GiftCardsPage